<template>
  <div>
    <megabit-base-dialog :show-dialog="true" :width="1920">
      <template v-slot:body>
        <v-card color="rgba(0, 0, 0, 0.92)" dark dense>
          <v-card-title class="align-self-center">
            <span class="text-h6 white--text"
              >{{ $t('menu-home.empresalistas') }} (alt+r)</span
            >
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="formValid">
              <v-row dense>
                <v-col md="3" xs="3" sm="12" class="d-sm-inline-block">
                  <v-row dense class="d-block">
                    <v-col md="12" xs="12" sm="12" class="d-sm-inline-block">
                      <c-input
                        :label="$t('labels.titulo')"
                        :placeholder="
                          `${$t('labels.titulo')} ${$t('labels.listaProdutos')}`
                        "
                        :maxLength="50"
                        :minLength="3"
                        :isRequired="true"
                        v-model="form.NOME"
                      />
                    </v-col>
                  </v-row>
                  <v-row dense class="d-block">
                    <v-col md="12" xs="12" sm="12" class="d-sm-inline-block">
                      <c-select
                        item-text="DESCRICAO"
                        item-value="CODIGO"
                        :lista="empresas"
                        :item.sync="form.empresa"
                        :rotulo="$t('labels.empresa')"
                        :hint="$t('labels.empresa')"
                        :isRequired="true"
                        v-model="form.CODIGO"
                        :loading="loadings.empresa"
                        @searchinput="updateDados($event, 'empresa')"
                      >
                      </c-select>
                    </v-col>
                  </v-row>
                  <v-row dense class="d-block">
                    <v-col md="12" xs="12" sm="12" class="d-sm-inline-block">
                      <c-input-date
                        :label="$t('labels.data')"
                        v-model.trim="form.DATA"
                        :isRequired="true"
                        :type="'date'"
                      />
                    </v-col>
                  </v-row>
                  <v-row dense class="d-block">
                    <v-col md="12" xs="12" sm="12" class="d-sm-inline-block">
                      <c-select
                        item-text="DESCRICAO"
                        item-value="CODIGO"
                        :lista="vendedores"
                        :item.sync="form.vendedor"
                        :disabled="true"
                        :rotulo="$t('labels.vendedor')"
                        :hint="$t('labels.vendedor')"
                        v-model="form.VENDEDOR"
                        :loading="loadings.vendedor"
                        @searchinput="updateDados($event, 'vendedor')"
                      >
                      </c-select>
                    </v-col>
                  </v-row>
                  <v-row dense class="d-block">
                    <v-col md="12" xs="12" sm="12" class="d-sm-inline-block">
                      <c-input-date
                        :disabled="true"
                        :label="$t('labels.dataInclusao')"
                        v-model.trim="form.DATAINCLUSAO"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col md="9" xs="9" sm="12" class="d-sm-inline-block">
                  <v-row dense class="d-block">
                    <v-col md="12" xs="12" sm="12" class="d-sm-inline-block">
                      <v-card>
                        <v-card-title>
                          <span class="text-h6">{{
                            $t('labels.listaProdutos')
                          }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-row dense>
                            <v-col
                              md="7"
                              xs="12"
                              sm="12"
                              class="d-sm-inline-block"
                            >
                              <v-row dense class="d-block">
                                <v-col
                                  md="3"
                                  xs="12"
                                  sm="12"
                                  class="d-sm-inline-block"
                                >
                                  <c-input
                                    :label="$t('labels.quantidade')"
                                    :placeholder="$t('labels.quantidade')"
                                    :maxLength="4"
                                    :isRequired="true"
                                    :type="'number'"
                                    min="1"
                                    v-model="quantidade"
                                  />
                                </v-col>
                                <v-col
                                  md="9"
                                  xs="12"
                                  sm="12"
                                  class="d-sm-inline-block"
                                >
                                  <c-select
                                    item-text="DESCRICAO"
                                    item-value="CODIGO"
                                    id="descricao"
                                    :lista="itensGetter"
                                    v-model="searchFields.text"
                                    :loading="loadings.item"
                                    :rotulo="$tc('labels.produto')"
                                    @searchinput="updateItens($event, 'search')"
                                    @input="updateItens($event, 'change')"
                                    @click="addEventos"
                                  />
                                </v-col>
                              </v-row>
                              <v-row dense class="d-block">
                                <v-col
                                  md="10"
                                  xs="12"
                                  sm="12"
                                  class="d-sm-inline-block"
                                >
                                  <c-input
                                    :label="$t('labels.complemento')"
                                    :placeholder="$t('labels.complemento')"
                                    :maxLength="50"
                                    v-model="complemento"
                                  />
                                </v-col>
                                <v-col
                                  md="1"
                                  xs="12"
                                  sm="12"
                                  class="d-sm-inline-block"
                                >
                                  <v-btn
                                    color="green"
                                    fab
                                    dark
                                    small
                                    @click="addItem()"
                                  >
                                    <v-icon>mdi-plus</v-icon></v-btn
                                  >
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col
                              md="4"
                              xs="12"
                              sm="12"
                              class="d-sm-inline-block p-4"
                              bgcolor="red"
                            >
                              <v-row
                                dense
                                class="d-block"
                                v-if="
                                  searchFields.selectedItem &&
                                    searchFields.selectedItem.imagens
                                "
                              >
                                <v-img
                                  max-height="150"
                                  height="150"
                                  width="300"
                                  max-width="300"
                                  contain
                                  :src="getImage(searchFields.selectedItem)"
                                  @click="
                                    toogleOverlay(searchFields.selectedItem)
                                  "
                                ></v-img>
                              </v-row>
                            </v-col>
                          </v-row>
                          <v-row class="d-block">
                            <v-col
                              md="12"
                              xs="12"
                              sm="12"
                              class="d-sm-inline-block"
                            >
                              <v-data-table
                                :headers="translatedHeader"
                                :items="selectedsItens"
                                item-key="form.CODIGO"
                                class="elevation-1"
                                :search="search"
                                :custom-filter="filterOnlyCapsText"
                                :disable-sort="disableSort"
                              >
                                <template v-slot:item.QUANTIDADE="props">
                                  <v-edit-dialog
                                    :return-value.sync="props.item.QUANTIDADE"
                                  >
                                    {{ parseInt(props.item.QUANTIDADE) }}
                                    <template v-slot:input>
                                      <v-text-field
                                        v-model.number="props.item.QUANTIDADE"
                                        :rules="[rules.required]"
                                        :label="$t('labels.editar')"
                                        :hint="$t('labels.editar')"
                                        type="'number'"
                                        single-line
                                        counter
                                        persistent-hint
                                        prepend-inner-icon="mdi-pencil"
                                        maxLength="3"
                                        @input="
                                          validaQuantidade(props.item.CODIGO)
                                        "
                                      ></v-text-field>
                                    </template>
                                  </v-edit-dialog>
                                </template>
                                <template v-slot:item.COMPLEMENTO="props">
                                  <v-edit-dialog
                                    :return-value.sync="props.item.COMPLEMENTO"
                                  >
                                    {{ props.item.COMPLEMENTO }}
                                    <template v-slot:input>
                                      <v-text-field
                                        v-model.number="props.item.COMPLEMENTO"
                                        :label="$t('labels.editar')"
                                        :hint="$t('labels.editar')"
                                        type="'text'"
                                        single-line
                                        counter
                                        persistent-hint
                                        prepend-inner-icon="mdi-pencil"
                                        maxLength="50"
                                      ></v-text-field>
                                    </template>
                                  </v-edit-dialog>
                                </template>
                                <template v-slot:item.QUANTIDADEPROC="{ item }">
                                  {{
                                    item.QUANTIDADEPROC
                                      ? parseInt(item.QUANTIDADEPROC)
                                      : 0
                                  }}
                                </template>
                                <template v-slot:top>
                                  <v-text-field
                                    v-model="search"
                                    :label="
                                      `${$t('labels.buscar')} por ${$t(
                                        'labels.codigo'
                                      )}`
                                    "
                                    class="mx-4"
                                  ></v-text-field>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                  <v-icon small @click="deleteItem(item)">
                                    mdi-delete
                                  </v-icon>
                                </template>
                                <template
                                  v-slot:item.imagens.image_name="{ item }"
                                >
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <span v-if="item.itens_complemento">
                                        <v-btn
                                          v-on="on"
                                          v-bind="attrs"
                                          x-small
                                          @click="toogleOverlay(item)"
                                        >
                                          <v-icon color="blue"
                                            >mdi-image-outline</v-icon
                                          >
                                        </v-btn>
                                      </span>
                                      <span v-else>
                                        <v-btn v-on="on" v-bind="attrs" x-small>
                                          <span class="red--text">X</span>
                                        </v-btn>
                                      </span>
                                    </template>
                                    <span v-if="item.imagens">{{
                                      $t('tabelas.verImagem')
                                    }}</span>
                                    <span v-else>{{
                                      $t('tabelas.semImagem')
                                    }}</span>
                                  </v-tooltip>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <form-buttons @submitForm="validateForm()" @goBack="goBack()" />
          <!-- Imagem overlay Component-->
          <overlayItem
            :isVisible="overlay.overlay"
            :isAbsolute="overlay.absolute"
            :imagesList="imagesList"
            :especificacoes="overlay.especificacoes"
            :item="overlay.item"
            :opacity="0.8"
            v-model="overlay.model"
            @closeOverlay="closeOverlay"
            :cycle="overlay.cycle"
          />
        </v-card>
      </template>
    </megabit-base-dialog>
    <confirm ref="confirm" v-model="confirm" />
    <router-view />
  </div>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cInput from '@/components/shared/base-input/BaseInput'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'
import cInputDate from '@/components/shared/base-input/BaseInputDate'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
import { mapActions, mapGetters } from 'vuex'
import Confirm from '@/components/shared/base-dialog/Confirm.vue'
import overlayItem from '@/components/shared/base-overlay/BaseOverlay'

export default {
  components: {
    'megabit-base-dialog': BaseDialog,
    cInput,
    cSelect,
    cInputDate,
    Confirm,
    FormButtons,
    overlayItem,
  },
  data: () => ({
    loadings: {
      empresa: false,
      vendedor: false,
      item: false,
    },
    disableSort: false,
    confirm: false,
    isUpdate: false,
    formValid: false,
    empresas: [],
    vendedores: [],
    selectedsItens: [],
    search: '',
    searchFields: {
      text: '',
      selectedItem: '',
    },
    quantidade: 1,
    complemento: '',
    snack: false,
    snackColor: '',
    snackText: '',
    timer: null,
    overlay: {
      overlay: false,
      cycle: false,
      absolute: false,
      color: 'dark',
      model: 0,
      especificacoes: '',
      item: {},
    },
    imagesList: [],
    headers: [
      {
        label: 'codigo',
        text: 'CODIGO',
        value: 'CODIGO',
      },
      {
        label: 'descricao',
        text: 'DESCRIÇÃO',
        value: 'itens.DESCRICAO',
      },
      { label: 'imagem', text: 'IMAGEM', value: 'imagens.image_name' },
      { label: 'complemento', text: 'COMPLEMENTO', value: 'COMPLEMENTO' },
      {
        label: 'quantidade',
        text: 'QNT',
        value: 'QUANTIDADE',
        align: 'center',
      },
      {
        text: 'QNT PROC',
        value: 'QUANTIDADEPROC',
        align: 'center',
      },
      {
        label: 'acoes',
        text: 'Ações',
        value: 'actions',
        sortable: false,
        align: 'center',
      },
    ],
    form: {
      SEQUENCIAL: '',
      CODIGO: '',
      NOME: '',
      VENDEDOR: '',
      DATA: null,
      DATAINCLUSAO: '',
      empresa: '',
      vendedor: '',
      produtos: '',
      excluidos: '',
    },
  }),
  computed: {
    ...mapGetters({ company: 'companyModule/getComboBoxList' }),
    ...mapGetters({ users: 'userModule/getUsersList' }),
    ...mapGetters({ itensGetter: 'itemModule/getComboBoxList' }),

    translatedHeader() {
      return this.headers.map((element) => {
        if (element.label)
          element.text = this.$i18n.t(`labels.${element.label}`)

        return element
      })
    },
    rules() {
      const rules = {
        required: (value) =>
          !!value || this.$i18n.t('validation-messages.requiredField'),
        counter: (value) =>
          value.length <= 3 ||
          this.$i18n.t('validation-messages.maxLength', { quantidade: 3 }),
      }
      return rules
    },
    // Ver o breakpoint da página
    // breakpoint() {
    //   return this.$vuetify.breakpoint.name;
    // },
  },
  methods: {
    ...mapActions('companyListModule', [
      'getCompanyListList',
      'updateCompanyList',
      'insertCompanyList',
    ]),
    ...mapActions('companyModule', ['getCompanies']),
    ...mapActions('userModule', ['getUsersAPI']),
    ...mapActions('itemModule', ['getItens']),
    ...mapActions({
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setMessage: 'dialogModule/setLoadingDialogMessage',
    }),

    async validateForm() {
      if (!this.$refs.form.validate()) {
        this.$toasted.error(this.$i18n.t('validation-messages.corrigir'), {
          duration: null,
        })
        this.$i18n.t('validation-messages.corrigir')
        return
      }
      if (!this.form.DATA) {
        this.$toasted.error(this.$i18n.t('validation-messages.dataInvalida'), {
          duration: null,
        })
        return
      }
      try {
        this.setMessage(this.$i18n.t('messages.enviarRegistro'))
        this.showLoadingDialog(true)
        let response
        if (!this.isUpdate) {
          this.form.produtos = this.selectedsItens
          response = await this.insertCompanyList(this.form)
        } else {
          response = await this.updateCompanyList({
            form: this.form,
            id: this.form.SEQUENCIAL,
          })
        }
        this.$toasted.success(response)
        this.$router.push({ name: 'EmpresaListas' })
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    // Desabilita a ordenação em telas pequenas "xs"
    updateSort() {
      let name = this.$vuetify.breakpoint.name
      this.disableSort = name == 'xs' ? true : false
    },
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value
          .toString()
          .toLocaleUpperCase()
          .indexOf(search) !== -1
      )
    },
    async updateItens($event, tipo) {
      try {
        if (tipo == 'search') {
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            let param =
              $event.target.value && $event.target.value
                ? $event.target.value
                : null
            let obj = { page: 1, hibrido: param }
            this.getDados(obj, 'item')
          }, 600)
        } else if (tipo == 'change') {
          this.searchFields.selectedItem = $event
          this.selectedsItens.map((e) => {
            if (
              this.searchFields.selectedItem &&
              e.CODIGO == this.searchFields.selectedItem.CODIGO
            ) {
              this.quantidade = parseInt(e.QUANTIDADE)
              this.complemento = e.COMPLEMENTO
              this.$toasted.info(
                this.$i18n.t('validation-messages.itemRepetido')
              )
            }
          })
        }
      } catch (error) {
        this.$toasted.error(error)
      }
    },
    addItem() {
      let achouItem = false
      this.selectedsItens.map((e) => {
        if (e.CODIGO == this.searchFields.selectedItem.CODIGO) {
          e.QUANTIDADE = parseInt(this.quantidade)
          e.COMPLEMENTO = this.complemento
          achouItem = true
        }
      })
      if (!achouItem) {
        if (this.searchFields.selectedItem.CODIGO) {
          this.selectedsItens.push({
            ...this.searchFields.selectedItem,
            CODIGO: this.searchFields.selectedItem.CODIGO,
            QUANTIDADE: this.quantidade,
            COMPLEMENTO: this.complemento,
            itens: {
              DESCRICAO: this.searchFields.selectedItem.DESCRICAO1,
            },
          })
        }
      }
      this.quantidade = 1
      this.complemento = ''
    },
    async deleteItem(item) {
      if (
        await this.$refs.confirm.open(
          this.$i18n.t('labels.excluir'),
          this.$i18n.t('dialogs.exclusao', {
            nome: 'item',
            codigo: item.CODIGO,
          }),
          { color: 'red' }
        )
      ) {
        const result = this.selectedsItens.filter((e) => {
          return e.CODIGO != item.CODIGO
        })
        if (item.SEQUENCIAL) {
          this.form.excluidos.push({
            CODIGO: item.CODIGO,
            SEQUENCIAL: item.SEQUENCIAL,
          })
        }
        this.selectedsItens = result
        this.form.produtos = result
      } else {
        return
      }
    },
    validaQuantidade($event) {
      this.form.produtos.map((e) => {
        if (e.CODIGO == $event) {
          if (typeof e.QUANTIDADE == 'string') {
            e.QUANTIDADE = 1
            return e.QUANTIDADE
          }
        }
      })
    },
    closeOverlay() {
      this.overlay.overlay = false
    },
    toogleOverlay(item = null) {
      const imagensName = ['IMAGEM', 'IMAGEM1', 'IMAGEM2', 'IMAGEM3']
      this.imagesList = []
      this.overlay.model = 0
      this.overlay.item = {
        CODIGO: item.itens ? item.itens.CODIGO : item.CODIGO,
        DESCRICAO: item.itens ? item.itens.DESCRICAO : item.DESCRICAO1,
      }
      if (!item.itens_complemento) return
      let dados = item.itens_complemento ?? null
      if (dados) {
        this.overlay.overlay = !this.overlay.overlay
        this.overlay.especificacoes = dados.ESPECIFICACOES
        imagensName.forEach((key) => {
          if (dados[key]) {
            let path = 'data:image/jpg;base64,' + dados[key]
            this.imagesList.push(path)
          }
        })
      }
    },
    getImage(item = null) {
      let path
      if (item && item.itens_complemento) {
        path = 'data:image/jpg;base64,' + item.itens_complemento.IMAGEM
      }
      return path
    },
    goBack() {
      this.$router.push({ name: 'EmpresaListas' })
    },
    async setData(sequencial = null) {
      try {
        if (sequencial) {
          let companyList1 = await this.getCompanyListList(sequencial)
          this.form = await {
            ...companyList1,
          }
          this.form.produtos.map((e) => {
            e.QUANTIDADE = parseInt(e.QUANTIDADE)
          })
          // Preenche o select Empresa com o valor incial do banco
          let emp = this.form.empresa
            ? [
                {
                  CODIGO: this.form.empresa.CODIGO,
                  DESCRICAO: this.form.empresa.NOME,
                },
              ]
            : [{ CODIGO: '', DESCRICAO: this.$t('labels.semDados') }]
          this.empresas = emp
          // Preenche o select Vendedor com o valor incial do banco
          let vend = this.form.vendedor
            ? [
                {
                  CODIGO: this.form.vendedor.CODIGO,
                  DESCRICAO: this.form.vendedor.NOME,
                },
              ]
            : [{ CODIGO: '', DESCRICAO: this.$t('labels.semDados') }]
          this.vendedores = vend

          this.selectedsItens = this.form.produtos
          this.itens = [{ CODIGO: '', DESCRICAO: 'Pesquisar' }]
          this.form.excluidos = []
          this.isUpdate = !this.isUpdate
        } else {
          // Inclusão de Lista de Produtos
          // await this.getFiliais();
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    /*  Atualiza ComboBox da Empresa
     */
    async updateDados($event, tipo) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event && $event.target.value ? $event.target.value : null
          let obj = parseInt(param)
            ? { page: 1, codigo: parseInt(param) }
            : { page: 1, nome: param }
          this.getDados(obj, tipo)
        }, 600)
      } catch (error) {
        this.$toasted.error(`Erro na função updateDados() ${error}`)
      }
    },
    async getDados(payload, tipo) {
      try {
        this.loadings[tipo] = true
        if (tipo == 'empresa') {
          await this.getCompanies(payload)
          this.empresas = this.company
        } else if (tipo == 'vendedor') {
          await this.getUsersAPI(payload)
          this.vendedores = this.users
        } else if (tipo == 'item') {
          await this.getItens({ query: payload })
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.loadings[tipo] = false
        this.addEventos()
      }
    },
    addEventos() {
      this.$nextTick(async function() {
        const e = document.getElementsByClassName('v-application')[0]
        let ele = ''
        if (e)
          ele = e.getElementsByClassName(
            'v-menu__content v-autocomplete__content'
          )
        setTimeout(() => {
          if (ele.item(0)) {
            const ele1 = ele
              .item(0)
              .getElementsByClassName('v-list-item__title')
            for (let index = 0; index < ele1.length - 1; index++) {
              ele1[index].addEventListener(
                'mouseenter',
                this.showImageOnMouseEnter,
                false
              )
            }
          }
        }, 250)
      })
    },
    showImageOnMouseEnter: function(e) {
      const textContent = e.target.textContent
      const split = textContent.split(' ')
      const codigoItem = split[0]
      const item = this.itensGetter.filter((e) => e.CODIGO == codigoItem)
      if (item.length > 0) {
        this.searchFields.selectedItem = item[0]
      } else {
        this.searchFields.selectedItem = ''
      }
    },
    removeEventos() {
      document.removeEventListener('mouseenter', this.showImageOnMouseEnter)
    },
  },
  mounted: async function() {
    this.sequencial = this.$route.params.id
    this.updateSort()
    await this.setData(this.sequencial)
  },
  destroyed: function() {
    this.removeEventos()
  },
}
</script>
